import React from 'react';
import { ShareAltOutlined } from '@ant-design/icons';
import { Button } from 'antd';

export const Share = () => {
    const shareData = {
        title: `Check out PartsBadger's QuickTurn Part Designer`,
        text: `I just wanted to share an awesome online portal with you where you can design your own custom parts, add them to your cart, and order them online. It's super easy to use, and you can customize the material, features, and dimensions.
        
        I think you'll really like it, and it's a great resource for anyone who needs custom parts.`,
        url: 'https://portal.parts-badger.com/quick-turn/design?utm_source=share',
    };

    return navigator.share ? (
        <>
            <Button
                type="default"
                size="small"
                block
                style={{ fontWeight: 600 }}
                // style={{ borderColor: '#b1d3da', background: '#ecf7ff' }}
                icon={<ShareAltOutlined />}
                onClick={async () => {
                    try {
                        await navigator.share(shareData);
                    } catch (err) {
                        console.log(`Error: ${err}`);
                    }
                }}
            >
                Share
            </Button>
        </>
    ) : null;
};
